import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../config';
import './HomePage.css';

const HomePage = ({ telegramId, onSectionChange }) => {
  // Состояния для данных плиток
  const [usersCount, setUsersCount] = useState(0);
  const [activitiesCount, setActivitiesCount] = useState(0);
  const [remainingInvites, setRemainingInvites] = useState(0);
  // const [userRating, setUserRating] = useState(0); // Рейтинг убран
  const [unreadMessages, setUnreadMessages] = useState(0);

  // Состояния для загрузки
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Получение всех данных для дашборда при загрузке компонента
  useEffect(() => {
    if (!telegramId) return;

    const fetchDashboardData = async () => {
      setIsLoading(true);
      setError(null);
      // Сбрасываем счетчики перед загрузкой
      setUsersCount(0);
      setActivitiesCount(0);
      setRemainingInvites(0);
      setUnreadMessages(0);

      try {
        // --- 1. Получаем количество пользователей ---
        const usersFormData = new FormData();
        usersFormData.append('telegram_id', telegramId);
        usersFormData.append('search_scope', 'all');

        const usersResponse = await fetch(getApiUrl('/api/get_chain'), {
          method: 'POST',
          body: usersFormData
        });
        console.log('[HomePage] /api/get_chain response status:', usersResponse.status);
        const responseTextUsers = await usersResponse.text(); // Читаем как текст
        console.log('[HomePage] /api/get_chain raw response text:', responseTextUsers); // Логируем текст

        if (!usersResponse.ok) {
          // Ошибка уже обработана ниже, но можно добавить лог статуса
          console.error(`[HomePage] /api/get_chain failed with status: ${usersResponse.status}`);
        } else {
          try {
            const usersData = JSON.parse(responseTextUsers); // Парсим текст
            setUsersCount(usersData.count !== undefined ? usersData.count : 0);
          } catch (parseError) {
            console.error('[HomePage] Failed to parse /api/get_chain response as JSON:', parseError, `|| Response Text: ${responseTextUsers.substring(0, 100)}...`);
            // Устанавливаем ошибку для отображения в UI
            setError(`Ошибка данных пользователей: Неверный формат ответа.`);
            // Не бросаем ошибку дальше, чтобы другие запросы выполнились
          }
        }

        // --- 2. Получаем количество активностей ---
        try {
          const activitiesResponse = await fetch(getApiUrl(`/api/activities/list${telegramId ? `?telegram_id=${telegramId}` : ''}`));
          console.log('[HomePage] /api/activities/list response status:', activitiesResponse.status);
          const responseTextActivities = await activitiesResponse.text(); // Читаем как текст
          console.log('[HomePage] /api/activities/list raw response text:', responseTextActivities); // Логируем текст

          if (!activitiesResponse.ok) {
            console.error(`[HomePage] /api/activities/list failed with status: ${activitiesResponse.status}`);
          } else {
            try {
              const activitiesData = JSON.parse(responseTextActivities); // Парсим текст
              setActivitiesCount(activitiesData.total_count !== undefined ? activitiesData.total_count : 0);
            } catch (parseError) {
              console.error('[HomePage] Failed to parse /api/activities/list response as JSON:', parseError, `|| Response Text: ${responseTextActivities.substring(0, 100)}...`);
              // Можно добавить setError, если это критично
            }
          }
        } catch (activityErr) {
          console.error("Ошибка при загрузке активностей (fetch):", activityErr);
          // Можно добавить setError
        }

        // --- 3. Получаем количество оставшихся инвайтов ---
        try {
          // ВАЖНО: Этот эндпоинт НЕ начинается с /api/ в вашем urls.py! Оставляем как есть.
          const invitesResponse = await fetch(getApiUrl(`/api/remaining_invites/${telegramId}`));
          console.log(`[HomePage] /remaining_invites/${telegramId} response status:`, invitesResponse.status);
          const responseTextInvites = await invitesResponse.text(); // Читаем как текст
          console.log(`[HomePage] /remaining_invites/${telegramId} raw response text:`, responseTextInvites); // Логируем текст

          if (!invitesResponse.ok) {
            console.error(`[HomePage] /remaining_invites/${telegramId} failed with status: ${invitesResponse.status}`);
          } else {
            try {
              const invitesData = JSON.parse(responseTextInvites); // Парсим текст
              setRemainingInvites(invitesData.remaining_invites !== undefined ? invitesData.remaining_invites : 0);
            } catch (parseError) {
              console.error(`[HomePage] Failed to parse /remaining_invites/${telegramId} response as JSON:`, parseError, `|| Response Text: ${responseTextInvites.substring(0, 100)}...`);
              // Можно добавить setError
            }
          }
        } catch (invitesErr) {
          console.error('Ошибка при загрузке инвайтов (fetch):', invitesErr);
          // Можно добавить setError
        }

        // --- 4. Получаем количество непрочитанных сообщений ---
        try {
          const notificationFormData = new FormData();
          notificationFormData.append('telegram_id', telegramId);
          const notificationsResponse = await fetch(getApiUrl('/api/get_my_notifications'), {
            method: 'POST',
            body: notificationFormData
          });
          console.log('[HomePage] /api/get_my_notifications response status:', notificationsResponse.status);
          const responseTextNotifications = await notificationsResponse.text(); // Читаем как текст
          console.log('[HomePage] /api/get_my_notifications raw response text:', responseTextNotifications); // Логируем текст

          if (!notificationsResponse.ok) {
            console.error(`[HomePage] /api/get_my_notifications failed with status: ${notificationsResponse.status}`);
          } else {
            try {
              const notificationsData = JSON.parse(responseTextNotifications); // Парсим текст
              if (notificationsData && notificationsData.notifications) {
                const unread = notificationsData.notifications.filter(n => !n.is_read).length;
                setUnreadMessages(unread);
              } else {
                setUnreadMessages(0);
              }
            } catch (parseError) {
              console.error('[HomePage] Failed to parse /api/get_my_notifications response as JSON:', parseError, `|| Response Text: ${responseTextNotifications.substring(0, 100)}...`);
              setUnreadMessages(0);
              // Можно добавить setError
            }
          }
        } catch (notificationsErr) {
          console.error('Ошибка при загрузке уведомлений (fetch):', notificationsErr);
          // Можно добавить setError
        }

      } catch (err) { // Этот catch ловит ошибки fetch, если они не были обработаны выше
        console.error('Общая ошибка при загрузке данных для дашборда:', err);
        // Устанавливаем общую ошибку, если какой-то из запросов упал критично
        if (!error) { // Устанавливаем ошибку, только если она еще не установлена парсером
          setError(err.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchDashboardData();
  }, [telegramId]);

  // Рендеринг плиток дашборда
  return (
    <div className="home-page">
      {/* <h1 className="dashboard-title">Дашборд</h1> */}

      {isLoading ? (
        <div className="dashboard-loading">
          <div className="loader"></div>
          <p>Загрузка данных...</p>
        </div>
      ) : error ? (
        <div className="dashboard-error">
          <p>Ошибка при загрузке данных: {error}</p>
          <button onClick={() => window.location.reload()} className="button button-primary">Попробовать снова</button>
        </div>
      ) : (
        <div className="dashboard-grid">
          {/* Плитка 1: Количество пользователей */}
          <div className="dashboard-tile users-tile" onClick={() => onSectionChange('chain')}>
            <div className="tile-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div className="tile-content">
              <h3>Участников</h3>
              <div className="tile-number">{usersCount}</div>
              <p className="tile-description">в сети</p> {/* Изменил текст */}
            </div>
          </div>

          {/* Плитка 2: Количество активностей */}
          <div className="dashboard-tile activities-tile" onClick={() => onSectionChange('activities')}>
            <div className="tile-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
            <div className="tile-content">
              <h3>Активности</h3>
              <div className="tile-number">{activitiesCount}</div>
              <p className="tile-description">созданных активностей</p>
            </div>
          </div>

          {/* Плитка 3: Количество инвайтов */}
          <div className="dashboard-tile invites-tile" onClick={() => onSectionChange('invites')}>
            <div className="tile-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
              </svg>
            </div>
            <div className="tile-content">
              <h3>Инвайты</h3>
              <div className="tile-number">{remainingInvites}</div>
              <p className="tile-description">доступно для использования</p>
            </div>
          </div>

          {/* --- ПЛИТКА РЕЙТИНГА УДАЛЕНА --- */}

          {/* Плитка 4 (бывшая 5): Непрочитанные сообщения */}
          <div className="dashboard-tile messages-tile" onClick={() => onSectionChange('notifications')}>
            <div className="tile-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div className="tile-content">
              <h3>Сообщения</h3>
              <div className="tile-number">{unreadMessages}</div>
              <p className="tile-description">
                {unreadMessages > 0 ? 'непрочитанных' : 'нет непрочитанных'} {/* Изменил текст */}
              </p>
            </div>
          </div>

          {/* Плитка Графа связей */}
          <div 
            className="dashboard-tile graph-tile" 
            onClick={() => onSectionChange('dependencyGraph')}
          >
            <div className="tile-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
            </div>
            <div className="tile-content">
              <h3>Граф связей</h3>
              <p className="tile-description">Визуализация вашей сети</p>
            </div>
          </div>

          {/* НОВАЯ ПЛИТКА "О ПРИЛОЖЕНИИ" */}
          <div  
            className="dashboard-tile about-tile"  
            onClick={() => onSectionChange('about')}  
          > 
            {/* <div className="tile-icon">ℹ️</div> */}
            <div className="tile-content"> 
              <h3>О приложении</h3>  
              {/* <p className="tile-description">Узнайте больше о VINCLE</p> */}
            </div> 
          </div>

        </div>
      )}
    </div>
  );
};

export default HomePage;